













 











const node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isInvited"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "isInvited",
        "variableName": "isInvited"
      }
    ],
    "kind": "ScalarField",
    "name": "SAMLIdP",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getSAMLIdPQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getSAMLIdPQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "q_1y0gShzGayXoAVh9kq3kEg",
    "metadata": {},
    "name": "getSAMLIdPQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node ).hash = "43667c85a3ff7499f01d739e1240b615";

export default node;
